import { Config } from './config';
import { Util } from './util';
import AmountFormatter from '../../libraries/amount-formatter'

class SearchForm {

    constructor() {
        this.CONFIG = new Config();
        this.AMOUNT_FORMATTER = new AmountFormatter();
        this.SEARCH_FORM = document.forms['searchForm'];
        this.SEARCH_FORM_LAST_ID = this.SEARCH_FORM['complaint[last_id]'];
        this.SEARCH_FORM_PER_PAGE = this.SEARCH_FORM['complaint[per_page]'];
        this.SEARCH_FORM_SHOP_ID = this.SEARCH_FORM['complaint[shop_id]'];
        this.SEARCH_FORM_USERNAME = this.SEARCH_FORM['complaint[username]'];
        this.SEARCH_FORM_INQUIRY_SOURCE_TYPE = this.SEARCH_FORM['complaint[complaint_contacts_attributes][0][inquiry_source_type]'];
        this.SEARCH_FORM_CARD_NUMBER_PREFIX = this.SEARCH_FORM['complaint[complaint_transactions_attributes][0][card_number_prefix]'];
        this.SEARCH_FORM_CARD_NUMBER_SUFFIX = this.SEARCH_FORM['complaint[complaint_transactions_attributes][0][card_number_suffix]'];
        this.SEARCH_FORM_TRANSACTION_CODE = this.SEARCH_FORM['complaint[complaint_transactions_attributes][0][transaction_code]'];
        this.SEARCH_FORM_TRANSACTION_DATE = this.SEARCH_FORM['complaint[complaint_transactions_attributes][0][transaction_date]'];
        this.SEARCH_FORM_AMOUNT = this.SEARCH_FORM['complaint[complaint_transactions_attributes][0][amount]'];
        this.SEARCH_FORM_ACTION_REQUIRED = this.SEARCH_FORM['complaint[complaint_transactions_attributes][0][action_required_flag]'];
        this.SEARCH_FORM_DEADLINE_BEGIN = this.SEARCH_FORM['complaint[deadline_begin]'];
        this.SEARCH_FORM_DEADLINE_END = this.SEARCH_FORM['complaint[deadline_end]'];
        this.SEARCH_FORM_STATUS_CLASSIFICATION = this.SEARCH_FORM['complaint[status_classification]'];
        this.SEARCH_FORM_STATUS = this.SEARCH_FORM['complaint[status]'];
        this.SEARCH_FORM_NOTIFICATION_TYPE = this.SEARCH_FORM['complaint[notification_type]'];
        this.SEARCH_FORM_BTN = this.SEARCH_FORM['search'];
        this.IS_JSON_AVAILABLE = true;
        this.JSON_LAST_ID = 0;
        this.JSON_PER_PAGE = 20;
        this.JSON_IS_SEARCHING_MORE = false;
        this.JSON_HAS_MORE = true;
        this.CUSTOM_EVENT_SEARCH_BEFORE = 'searchbefore';
        this.CUSTOM_EVENT_SEARCHED = 'searched';
        this.CUSTOM_EVENT_SEARCH_COMPLETE = 'searchcomplete';
    }


    GetRootElm() {
        return this.SEARCH_FORM;
    }


    SetNoMoreComplaints() {
        this.JSON_HAS_MORE = false;
    }


    GetMoreComplaints() {
        if(!this.JSON_HAS_MORE) {
            return;
        }
        this.JSON_IS_SEARCHING_MORE = true;
        this.SEARCH_FORM_BTN.click();
    }


    handleBefore(e) {
        if(e.target.tagName !== 'FORM') {
           return;
        }
        if(!this.JSON_IS_SEARCHING_MORE) {
            this.JSON_LAST_ID = 0;
            this.JSON_IS_SEARCHING_MORE = false;
            this.JSON_HAS_MORE = true;
        }
        this.SEARCH_FORM_LAST_ID.value = this.JSON_LAST_ID;
        this.SEARCH_FORM_PER_PAGE.value = this.JSON_PER_PAGE;
    }


    handleBeforeSend(e) {
        if(e.target.tagName !== 'FORM') {
           return;
        }
        if(!this.IS_JSON_AVAILABLE || !this.JSON_HAS_MORE) {
            e.preventDefault();
        }
        this.IS_JSON_AVAILABLE = false;
        Util.DelDomValidateError();
        const event = new CustomEvent(this.CUSTOM_EVENT_SEARCH_BEFORE, {
            detail: {
                isSearchingMore: this.JSON_IS_SEARCHING_MORE
            }
        });
        this.SEARCH_FORM.dispatchEvent(event);
    }


    handleSuccess(e) {
        if(e.target.tagName !== 'FORM') {
           return;
        }
        const detail = e.detail[0];
        let isNotFound = false;
        if(detail['complaints'] != null && detail['complaints'].length > 0) {
            this.JSON_LAST_ID = detail['complaints'][detail['complaints'].length-1]['id'];
        } else {
            this.JSON_HAS_MORE = false;
            if(this.JSON_LAST_ID === 0) {
                isNotFound = true;
            }
        }

        const event = new CustomEvent(this.CUSTOM_EVENT_SEARCHED, {
            detail: {
                objects: e.detail[0],
                isNotFound: isNotFound
            }
        });
        this.SEARCH_FORM.dispatchEvent(event);
    }


    handleError(e) {
        if(e.target.tagName !== 'FORM') {
           return;
        }
        if(e.detail[2] != null && e.detail[2].status === 401) {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(e.detail[0]), this.CONFIG.APP_MAIN.childNodes[0]);
            window.scrollTo(0,0)
            return;
        }
        const detail = e.detail[0];
        if(detail == null) {
            return;
        }
        const msg = detail.msg;
        const valid = detail.valid;
        if(msg != null && msg !== '') {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(msg), this.CONFIG.APP_MAIN.childNodes[0]);
        }
        if(valid != null) {
            if(valid['shop_id'] != null && valid['shop_id'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_SHOP_ID, valid['shop_id'][0]);
            }
            if(valid['username'] != null && valid['username'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_USERNAME, valid['username'][0]);
            }
            if(valid['complaint_contacts.inquiry_source_type'] != null && valid['complaint_contacts.inquiry_source_type'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_INQUIRY_SOURCE_TYPE, valid['complaint_contacts.inquiry_source_type'][0]);
            }
            if(valid['complaint_transactions.card_number_prefix'] != null && valid['complaint_transactions.card_number_prefix'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_CARD_NUMBER_PREFIX, valid['complaint_transactions.card_number_prefix'][0]);
            }
            if(valid['complaint_transactions.card_number_suffix'] != null && valid['complaint_transactions.card_number_suffix'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_CARD_NUMBER_SUFFIX, valid['complaint_transactions.card_number_suffix'][0]);
            }
            if(valid['complaint_transactions.transaction_code'] != null && valid['complaint_transactions.transaction_code'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_TRANSACTION_CODE, valid['complaint_transactions.transaction_code'][0]);
            }
            if(valid['complaint_transactions.amount'] != null && valid['complaint_transactions.amount'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_AMOUNT, valid['complaint_transactions.amount'][0]);
            }
            if(valid['deadline_begin'] != null && valid['deadline_begin'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_DEADLINE_BEGIN, valid['deadline_begin'][0]);
            }
            if(valid['deadline_end'] != null && valid['deadline_end'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_DEADLINE_END, valid['deadline_end'][0]);
            }
            if(valid['complaint_transactions.action_required_flag'] != null && valid['action_required_flag'][0] != null) {
                Util.GenDomValidateError(this.SEARCH_FORM_ACTION_REQUIRED, valid['action_required_flag'][0]);
            }
        }
        window.scrollTo(0, 0);
        this.JSON_HAS_MORE = false;
    }


    handleComplete(e) {
        if(e.target.tagName !== 'FORM') {
           return;
        }
        this.IS_JSON_AVAILABLE = true;
        this.JSON_IS_SEARCHING_MORE = false;
        this.AMOUNT_FORMATTER.format(this.SEARCH_FORM_AMOUNT);
        const event = new CustomEvent(this.CUSTOM_EVENT_SEARCH_COMPLETE);
        this.SEARCH_FORM.dispatchEvent(event);
    }


    setUpRailsUjsEventListener() {
        document.body.addEventListener('ajax:before', (e) => { this.handleBefore(e) }, false);
        document.body.addEventListener('ajax:beforeSend', (e) => { this.handleBeforeSend(e) }, false);
        document.body.addEventListener('ajax:success', (e) => { this.handleSuccess(e) }, false);
        document.body.addEventListener('ajax:error', (e) => { this.handleError(e) }, false);
        document.body.addEventListener('ajax:complete', (e) => { this.handleComplete(e) }, false);
    }


    Run() {
        this.setUpRailsUjsEventListener();
        this.SEARCH_FORM_BTN.click();
    }

}
export { SearchForm }
